// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3bNwe","row":"ProcedureTreatmentSummary_row__2dHgB"};